import React from 'react';
import { Controller, Control } from 'react-hook-form';
import moment from 'moment';

import { date2UTCFormat, utcString2Date } from 'utils/dateTime';

import DatePicker from './DatePicker';

interface ControlledDatePickerProps {
  name: string;
  control: Control<any>; // or you can specify your form data type here instead of any
  // plus any other props you want to forward to DatePicker
  [key: string]: any;
}

const ControlledDatePicker: React.FC<ControlledDatePickerProps> = ({ name, control, ...props }) => (
  <Controller
    control={control}
    name={name}
    render={({ field: { onChange, value } }) => (
      <DatePicker
        {...props}
        selected={utcString2Date(value)}
        onChange={(date) => {
          const initialDateStr = date
            ? date2UTCFormat(
              moment(date)
                .set({
                  hour: 12,
                  minute: 0,
                  second: 0,
                  millisecond: 0,
                })
                .toDate(),
            )
            : null;

          onChange(initialDateStr);
        }}
      />
    )}
  />
);

export default ControlledDatePicker;
